import Constants from 'expo-constants';
import { Platform } from 'react-native';

import { getApiKey } from 'utils/environment';

export const MAPS_API_KEY = Platform.select({
  ios: getApiKey({ key: 'googleMapsIOS' }),
  android: getApiKey({ key: 'googleMapsAndroid' }),
});

export const MAPS_HEADERS = {
  ...(Platform.OS === 'ios' && {
    'X-Ios-Bundle-Identifier': Constants.expoConfig?.ios?.bundleIdentifier || '',
  }),
  ...(Platform.OS === 'android' && {
    'X-Android-Package': Constants.expoConfig?.android?.package || '',
  }),
};
